import moment from "moment"

export const parseBatch = (value) => {
    let batch = value.split('-')
    return moment(batch[0], 'YYYYMMDD').format('YYYY/MM/DD') + ' - ' + moment(batch[1], 'YYYYMMDD').format('YYYY/MM/DD')
}

export const parseDigitalPlatforms = (value) => Object.keys(value).map((v) => value[v]).join(", ")